export default __webpack_public_path__ + "static/media/ishopify-admin-dashboard-mobile.979b245f.png";